// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import O1HD, { services } from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import utilsModel from "../../../../engines/libs/utilsModel";
import CsvDataManage from "../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../define/CsvFileKind";
import { GeneralKind } from "../../../define/GeneralKind";
import getOneBundle, { BUNDLE_SMALL_NAME } from "../../BundleResourceConfig";
import { backPackEventMap } from "../../config/BackpackEventConfig";
import NormalGameManager from "../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class EventGetGoodsLayer extends BasePopUpLayer {

	@property({ type: cc.Node, displayName:'' })
	nodeLayout: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	bg: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeGoodsLayout: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeGoods: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeExp: cc.Node = null;

	@property({ type: cc.Label, displayName:'' })
	labelSubExp: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelAddExp: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelCurExp: cc.Label = null;

	@property({ type: cc.Sprite, displayName:'' })
	sprOfficialBg: cc.Sprite = null;

    @property(cc.Label)
    labelOfficial: cc.Label = null;

    private csvInfos = null;

    private spaceY = 0;

    // LIFE-CYCLE CALLBACKS:

    start () {
        this.csvInfos = CsvDataManage.instance.getCsvData(CsvFileKind.CsvFile.LEVEL);
        this.spaceY = this.bg.height - this.nodeLayout.height;
        this.initLayer();
    }

    initLayer() {
        this.refreshLevel();
        this.showExp();
        this.showGoods();

        this.nodeLayout.getComponent(cc.Layout).updateLayout();
        this.bg.height = this.nodeLayout.height + this.spaceY;
    }

    async showGoods() {
        let addGold = this._carryData.addGold;
        let addGoodsList = this._carryData.addGoodsList;
        this.nodeGoods.active = false;
        if (addGold <= 0 && utilsModel.getJsonDataLength(addGoodsList) <= 0) {
            return;
        }
        this.nodeGoods.active = true;

        let children = this.nodeGoodsLayout.children;
        children.forEach((v)=> {
            v.active = false;
        })
        let idx = 0;
        if (addGold > 0) {
            let nodeItem = children[0];
            nodeItem.active = true;
            let label = nodeItem.getChildByName('label').getComponent(cc.Label);
            label.string = data_control.getNumberFormat(addGold);
            idx++;
        }
        for (let i in addGoodsList) {
            let nodeItem = children[idx];
            if (!nodeItem) {
                console.error(`超出限制`);
                break;
            }
            nodeItem.active = true;
            let num = addGoodsList[i];
            let label = nodeItem.getChildByName('label').getComponent(cc.Label);
            let sprGoods = nodeItem.getChildByName('sprGoods').getComponent(cc.Sprite);
            
            let goodsConfig = backPackEventMap()[i];
            let spPath:string = goodsConfig.spPath;
            label.string = goodsConfig.name + '×' + num;

            let gwidth = 93; //sprGoods.node.width;
            let gheight = 93; //sprGoods.node.height;
            sprGoods.node.active = false;
            if(spPath && spPath != ""){
                let bundle = await getOneBundle( BUNDLE_SMALL_NAME.backPackGameBundle );
                bundle.load(`backpackAssets/objSp/${spPath}`
                , cc.SpriteFrame
                , (err,imgs:cc.SpriteFrame)=>{
                    if(err){
                        console.log(err);
                    }else{
                        sprGoods.spriteFrame = imgs;
                        let scale = Math.min(gwidth / sprGoods.node.width, gheight / sprGoods.node.height);
                        sprGoods.node.scale = scale;
                        sprGoods.node.active = true;
                    }
                });
            }
            idx++;

        }
    }

    showExp() {
        let addExp = this._carryData.addExp;
        this.nodeExp.active = false;
        if (addExp == 0) {
            return;
        }
        this.nodeExp.active = true;
        let gameData = NormalGameManager._instance.getGameData();
        let exp = gameData.m_reputation;

        this.labelCurExp.string = '' + (exp - addExp);
        if (addExp > 0) {
            this.labelAddExp.node.active = true;
            this.labelSubExp.node.active = false;
            this.labelAddExp.string = '+' + addExp;
        } else {
            this.labelAddExp.node.active = false;
            this.labelSubExp.node.active = true;
            this.labelSubExp.string = '' + addExp;
        }

    }

    refreshLevel() {
        let title = this.csvInfos.title;
        let gameData = NormalGameManager._instance.getGameData();
        let officialLv = gameData.m_officialLv;
        let info = this.csvInfos[officialLv];
        if (!info) {
            console.error(`等级表格数据有误`);
            return;
        }

        this.labelOfficial.string = info[title.official_name];

        let icon = info[title.icon];
        O1HD.getManagers().gameMgr.getCurrMode().bundle.load(
            `res/user/levelIcon/official_bg_${icon}`
            , cc.SpriteFrame
            , ( error , assets : cc.SpriteFrame )=>
            {
                if ( error ) {
                    console.log("图片加载失败");
                    return
                }
                this.sprOfficialBg.spriteFrame = assets;
            }
        );

        this.labelOfficial.node.color = officialLv == GeneralKind.GeneralValue.MAX_LEVEL
            ? new cc.Color(0xff,0xe9,0xab) 
            : new cc.Color(0x00,0x00,0x00);
    }

    onClickConfirm() {
        this.destroyNode();
        this._carryData.onComplete();
    }

    onBtnShare(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        services().miniGameSrv.getAppApiInstance().shareGameRecordVideo(() => {
            // this.shareBtn.node.active = false;

        },(e)=>{

            // if(!this.timeIsVaild){
            //     O1HD.getModules().uiControlModule.showMessageBox("录屏小于3秒，分享失败");
            // }
        });
    }

    // update (dt) {}
}
